<sbw-layout [backButtonVisible]="true" [quoteModel]="quoteData" [quoteShowTotalPrice]="true"
    [quoteShowDepartureTime]="true" [form]="cabinFaresForm" continueButtonResource="CONTINUE"
    (continueEvent)="continue()" (backEvent)="navigateBack()">

    <div *ngIf="contentfulEditMode && flowCabinFaresContentfulEntry"
        class="contentfulContextEditor contentfulEditingImage">
        <a target="_blank"
            href="https://app.contentful.com/spaces/xtsdk79cmd4d/entries?id=KWHMYwmMql87YwEm&contentTypeId=flowCabinFares&contentTypeHidden=false&order.fieldId=updatedAt&order.direction=descending&displayedFieldIds=updatedAt&displayedFieldIds=author&displayedFieldIds=lM0vBVCnV8p1Oc0l">
            {{flowCabinFaresContentfulEntry.sys.contentType.sys.id}}
        </a>
        <span class="contentfulPathSeparator">/</span>
        <a class="contentfulEntryLink" target="_blank"
            href="https://app.contentful.com/spaces/xtsdk79cmd4d/entries/{{flowCabinFaresContentfulEntry.sys.id}}"><strong>{{flowCabinFaresContentfulEntry.fields.route}}</strong></a>
    </div>

    <div class="sbw_pagebox">
        <div class="uncollapse cabin-fares-container">
            <sbw-popup2 *ngIf="popup" [heading]="popup.title" >
                <span [innerHTML]="popup.contentText | markdown"></span>
                <div class="row">
                    <div class="column small-12 medium-6 field submit">
                        <sbw-button type="default" onClickState="activated" name="cabinfares-stay-button"
                            [text]="popup.stayButtonText" (clicked)="cancelPopup()"></sbw-button>
                    </div>
                    <div class="column small-12 medium-6 field submit">
                        <sbw-button type="preferred" name="continue-button" [text]="popup.continueButtonText"
                            (clicked)="closePopupAndPost()"></sbw-button>
                    </div>
                </div>
            </sbw-popup2>

            <div class="header" *ngIf="flowCabinFaresContent">
                <div class="row">
                    <div class="column medium-3 xlarge-2 hide-for-small-down">
                        <img src="/_ng/booking/assets/cabin-seaview.svg">
                    </div>
                    <div class="column medium-9 xlarge-10">
                        <h1>{{flowCabinFaresContent.headline}}</h1>
                    </div>
                    <div class="column medium-9 xlarge-10">
                        <p *ngIf="flowCabinFaresContent.legend" [innerHTML]="flowCabinFaresContent.legend | markdown">
                        </p>
                    </div>
                </div>
            </div>
            <sbw-validation-summary [errorList]="errorList"></sbw-validation-summary>
            <sbw-cabin-fares-group *ngIf="cabinFaresModel && cabinFaresModel.outbound"
                [form]="outboundFormGroup" [model]="cabinFaresModel.outbound" [reservation]="reservation"
                [content]="flowCabinFaresContent" [datePickerInfoLabel]="datePickerInfoLabel"></sbw-cabin-fares-group>
            <sbw-cabin-fares-group *ngIf="cabinFaresModel && cabinFaresModel.return"
                [form]="returnFormGroup" [model]="cabinFaresModel.return" [reservation]="reservation"
                [content]="flowCabinFaresContent" [datePickerInfoLabel]="datePickerInfoLabel"></sbw-cabin-fares-group>
        </div>
    </div>

</sbw-layout>
